import identifyQualifiedTraffic from "@utils/identifyQualifiedTraffic";
import { handleCustomUDL } from "@utils/UDLUtils";

export class BlurbV2 {
  private el: HTMLElement;
  private abortController: AbortController;

  constructor(el: HTMLElement) {
    this.el = el;
    this.abortController = new AbortController();
  }

  init(): void {
    const signal = this.abortController.signal;

    this.el
      .querySelectorAll<HTMLElement>('.cta[data-event-tracking="true"]')
      .forEach((cta) => {
        cta.addEventListener(
          "click",
          (e) => {
            const linkElement = e.currentTarget as HTMLElement;
            const blurbParams = this.getCommonParameters(linkElement);
            const customParams = { ...linkElement.dataset };
            delete customParams["eventTracking"];
            Object.assign(blurbParams, customParams);
            this.pushData(blurbParams);
          },
          { signal },
        );
      });
  }

  private getCommonParameters(
    linkElement: HTMLElement,
  ): Record<string, string | boolean> {
    const anchor = linkElement.querySelector<HTMLAnchorElement>("a");
    const link_url = anchor ? anchor.href : "";

    return {
      link_text: linkElement.innerText,
      link_url,
      ...identifyQualifiedTraffic(link_url),
    };
  }

  private pushData(blurbParams: Record<string, unknown>): void {
    handleCustomUDL("blurb", blurbParams);
  }

  destroy(): void {
    this.abortController.abort();
  }

  static initAll(root: Document | HTMLElement = document): void {
    root
      .querySelectorAll<HTMLElement>('[data-component="blurb-v2"]')
      .forEach((el) => {
        new BlurbV2(el).init();
      });
  }
}
